/* ============================================
   Portal del cliente — Mi perfil (layout con sub-navegación)
     /portal/perfil/personal   → identidad de la persona (contactos)
     /portal/perfil/empresa    → facturación del cliente activo (clientes)
     /portal/perfil/seguridad  → cambiar contraseña

   Lo usa el PORTAL DEL CLIENTE, que no tiene una pantalla de Configuración
   aparte: su perfil y los datos de su empresa viven juntos acá.

   El panel del partner ya no monta este layout. Ahí Mi perfil es solo la
   persona (`PartnerPerfil`) y los datos de la empresa, el equipo y las
   integraciones están en Configuración (`PartnerConfiguracion`): mezclarlos
   obligaba a entrar a "mi perfil" para cambiar algo de la empresa.
   ============================================ */

import { NavLink, Outlet } from 'react-router-dom'
import { Breadcrumbs } from '@/components/ui'
import { usePanelBase, useCrumbInicio } from '@/lib/portal-base'
import { PerfilProvider } from './perfil-contexto'

export type { Perfil } from './perfil-contexto'
export { usePerfilCtx } from './perfil-contexto'

const SECCIONES = [
  {
    slug: 'personal',
    label: 'Información personal',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    slug: 'empresa',
    label: 'Datos de la empresa',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18" /><path d="M5 21V7l8-4v18" /><path d="M19 21V11l-6-4" /><path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01" />
      </svg>
    ),
  },
  {
    slug: 'seguridad',
    label: 'Seguridad',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0110 0v4" />
      </svg>
    ),
  },
]

export default function PortalPerfilLayout() {
  const base = usePanelBase()
  const inicio = useCrumbInicio()

  return (
    <PerfilProvider>
      <div className="portal-page-enter pp-wrap">
        <Breadcrumbs items={[inicio, { label: 'Mi perfil' }]} />

        <div className="pp-layout">
          <nav className="pp-subnav" aria-label="Secciones de mi perfil">
            {SECCIONES.map(s => (
              <NavLink key={s.slug} to={`${base}/perfil/${s.slug}`} className={({ isActive }) => `pp-subnav-link ${isActive ? 'active' : ''}`}>
                <span className="pp-subnav-icon">{s.icon}</span>
                {s.label}
              </NavLink>
            ))}
          </nav>

          <section className="pp-section">
            <Outlet />
          </section>
        </div>
      </div>
    </PerfilProvider>
  )
}
